import { AioSelect } from "../additional/aioSelect";
import styles from "../aic.module.css";
import { AitCellData } from "./functions/AitCellData";
import { getBaseId } from "./functions/getBaseId";
import {
  AitCellJustifyText,
  AitHeaderCellData,
  AitLocationBodyCell,
  AitLocationHeaderCell,
  AitTablePosition,
  UPDATE_HEADER_CELL,
  UPDATE_TABLE_CELL,
} from "./functions/interface";
import { trGetCellFromLocation } from "./functions/trGetCellFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitCellAlignProps {
  location: AitLocationHeaderCell | AitLocationBodyCell;
}

/**
 * Render controls to set text justification for a cell.
 *
 * @template T - Cell payload type
 * @param props - Component props
 * @param props.location - The cell location (header or body)
 */
export const AitCellAlign = <T,>({ location }: AitCellAlignProps) => {
  const { state, dispatch } = useTableContext<T>();
  const thisCell: AitHeaderCellData<T> | AitCellData<T> | undefined = state?.processedTableData
    ? trGetCellFromLocation(state.processedTableData, location)
    : undefined;
  const id = getBaseId(location, state?.id);

  return !thisCell ? null : (
    <div className={styles.aiwBodyRow}>
      <AioSelect
        id={`${id}-justify`}
        label="Justify text"
        value={
          thisCell.justifyText === undefined
            ? "Default"
            : thisCell.justifyText.charAt(0).toUpperCase() +
              thisCell.justifyText.substring(1).toLowerCase()
        }
        availableValues={["Default", "Left", "Center", "Right", "Decimal"]}
        setValue={
          !thisCell.readOnly && !location.isRepeat
            ? (ret) =>
                location.position === AitTablePosition.headerCell
                  ? dispatch({
                      operation: UPDATE_HEADER_CELL,
                      location,
                      cellData: {
                        justifyText: ret.toLowerCase() as AitCellJustifyText,
                      },
                    })
                  : dispatch({
                      operation: UPDATE_TABLE_CELL,
                      location,
                      cellData: {
                        justifyText: ret.toLowerCase() as AitCellJustifyText,
                      },
                    })
            : undefined
        }
      />
    </div>
  );
};

AitCellAlign.displayName = "AitCellAlign";
